import React, { FC, memo, useEffect, useState } from "react"
import { SvgIcon } from "@montana/shared/svg-icon";
import { useTranslations } from "@montana/containers/translations";
import { TabletAndLarger } from "@montana/shared/responsive";

export interface IStoreLocatorSearchProps {
    searchStores: (searchQuery: string) => void;
}

export const StoreLocatorSearch: FC<IStoreLocatorSearchProps> = memo(({ searchStores }: IStoreLocatorSearchProps) => {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [isDirty, setIsDirty] = useState(false);
    const [showPlaceholder, setShowPlaceholder] = useState(true);
    const translate = useTranslations();

    useEffect(() => {
        if (!isDirty) {
            setIsDirty(true);
            return;
        }
        const debounceTimeOut = setTimeout(() => {
            searchStores(searchQuery);
        }, 350);

        return () => {
            clearTimeout(debounceTimeOut);
        }
    }, [searchQuery])

    return (
        <div className="store-locator__search">
            <SvgIcon iconName="search" className="store-locator__search__icon" />
            <div className="store-locator__search__input-wrapper">
                <input
                    className="store-locator__search__input text-input--basic"
                    value={searchQuery}
                    onFocus={() => setShowPlaceholder(false)}
                    onBlur={() => setShowPlaceholder(true)}
                    onChange={event => { setSearchQuery(event.target.value); }}
                />
                <div className="store-locator__search__input-extras">
                    <span className={`store-locator__search__placeholder${showPlaceholder && !searchQuery ? '' : ' store-locator__search__placeholder--hidden'}`}>
                        {translate((t: any) => t.storeLocator.searchPlaceholder, '[Find a dealer by searching on your City, zip code og Dealer name]')}
                    </span>
                </div>
            </div>
            <TabletAndLarger>
                <button className="store-locator__search__button" onClick={() => setSearchQuery('')} disabled={!searchQuery?.length}>
                    {translate((t: any) => t.storeLocator.searchButton, '[Reset]')}
                </button>
            </TabletAndLarger>
        </div>
    )
});
